import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Box } from '@mui/material';
import Page from 'components/Page';
import { getRoute } from '@common/constants/CampusRoutes';
import IndividualityItem from 'modules/Report/components/IndividualityItem';
import store from 'store';

import hobbiesSrc from '@common/assets/images/about-me/individuality/inner/hobbies.jpg';
import tallentsSrc from '@common/assets/images/about-me/individuality/inner/tallents.jpg';
import valuesSrc from '@common/assets/images/about-me/individuality/inner/values.jpg';
import useModel from '@common/helpers/useModel';
import StudentProfileModel, {
	IStudentProfileModel,
} from '@common/models/StudentProfile/StudentProfile';

function IndividualityPage() {
	const navigate = useNavigate();

	const studentProfile: IStudentProfileModel = useModel(
		StudentProfileModel,
		{ id: store.currentStudentId },
		[store.currentStudentId],
		{
			disableFetch: true,
		},
	);

	const handleGoBack = () => {
		navigate(getRoute(['REPORT', 'ABOUT']));
	};

	useEffect(() => {
		studentProfile.fetchStudent(!!store?.profile?.parent);
	}, []);

	return (
		<Page
			type="content"
			title="Individuality"
			onGoBack={handleGoBack}
			isLoading={studentProfile.loading}
		>
			<Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
				<IndividualityItem
					title="Hobbies"
					type="warning"
					items={studentProfile.individuality?.hobbies?.split(', ')}
					imageSrc={hobbiesSrc}
				/>
				<IndividualityItem
					title="Values"
					type="success"
					items={studentProfile.individuality?.values?.split(', ')}
					imageSrc={valuesSrc}
				/>
				<IndividualityItem
					title="Talents"
					type="info"
					items={studentProfile.individuality?.talents?.split(', ')}
					imageSrc={tallentsSrc}
				/>
			</Box>
		</Page>
	);
}

export default observer(IndividualityPage);
